<template>
  <v-layout row wrap mb-4 pa-4>
    <case-header-new></case-header-new>
    <v-flex xs12>
      <v-layout style="background:white !important" class="px-4 py-4 mb-0 elevation-2 rounded-3">
        <v-layout row wrap pa-4>
          <v-flex xs12>
            <h2 class="mb-1">Notifications</h2>
            <p>Set the notifications you receive from this case.</p>
          </v-flex>
          <v-flex xs12>
            <h3 class="primary--text pb-0 pt-3">Section Title</h3>
          </v-flex>
          <v-flex xs12>
            <v-container fluid pa-0 ma-0>
              <v-checkbox color="secondary" label="Lorem ipsum" v-model="checkbox"></v-checkbox>
              <h3 class="primary--text pb-0 pt-3">Section Title</h3>
              <v-radio-group v-model="radios" column>
                <v-radio color="secondary" label="Lorem ipsum dolor sit amet" value="1"></v-radio>
                <v-radio color="secondary" label="Lorem ipsum dolor sit amet" value="2"></v-radio>
              </v-radio-group>
              <h3 class="primary--text pb-0 pt-3">Section Title</h3>
              <v-switch v-model="switch1" color="secondary" label="Carpe diem"></v-switch>
              <v-switch v-model="switch2" color="secondary" label="Lorem ipsum"></v-switch>
              <v-switch v-model="switch3" color="secondary" label="Adit piscing"></v-switch>
              <v-switch v-model="switch4" color="secondary" label="Diem adit lorem ipsum carpe"></v-switch>
            </v-container>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout xs12>
        <v-btn color="error" @click="dialogDelete = true" class="mt-4 ml-0" dark>
          <v-icon>delete</v-icon>&emsp;Delete Case
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="500">
          <v-card class="pa-4">
            <v-card-title class="pa-0 pb-2">
              <h2>Are you sure you want to delete this case?</h2>
            </v-card-title>
            <v-card-text class="pa-0">
              <p>Lorem ipsum dolor sit amet</p>
            </v-card-text>
            <v-card-actions class="ma-0 pa-0 pt-1">
              <v-btn color="error">Yes, delete this case</v-btn>
              <v-btn @click="dialogDelete = false" color="secondary">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <v-btn class="mt-4 mb-0 mx-0" color="success" style="float:right">Save changes</v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew.vue"
export default {
  name: "case-notifications",
  data: () => ({
    checkbox: false,
    dialogDelete: false,
    switch1: true,
    switch2: false,
    switch3: true,
    switch4: false,
    radios: "1"
  }),
  components: {
    CaseHeaderNew
  }
}
</script>
